<div [class]="variant" (shClickOutside)="setDropdownClosed()">
    <button
        #droppanelToggle
        [id]="id"
        type="button"
        class="sh-icon-button sh-form-group__input sh-form-multiselect__select"
        (click)="toggleDropdown()"
        (keyup)="handleDeletePress($event)"
        [disabled]="disabled"
    >
        <span class="sh-form-multiselect__select__label" [title]="label">{{ label }}</span>
        <svg sh-icon class="sh-icon-button__icon--end push-right" [name]="'angle-down'" [size]="iconSize.SMALL" aria-hidden="true"></svg>
    </button>

    <div
        #droppanel
        [class]="inOverflownContainer ? 'sh-droppanel--fixed' : 'sh-droppanel'"
        [ngClass]="[openDirection, droppanelStyle]"
        [class.-sh-is-open]="isOpen$ | async"
    >
        <ng-content></ng-content>
    </div>
</div>
